import { Action } from '@ngrx/store';

export const USER_SIGNED_IN = '[Authorization] User Signed In';

export class UserSignedIn implements Action {
  public readonly type = USER_SIGNED_IN;
}

export type AuthorizationActions = UserSignedIn;
